export enum ERROR {
    IS_REQUIRED = 'IS_REQUIRED',
    INVALID_FORMAT = 'INVALID_FORMAT',
}

export const MASK = ['+', '7', ' ', '(', /\d/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/];
